import React from 'react';
import hasValidationErrors from 'components/connectedForm/utils/hasValidationErrors';
import { createBackgroundProcess } from 'utils/BackgroundJobs';
import NominalAccrualPrepaymentPostMutation from 'graphql/mutations/nominal/NominalAccrualPrepaymentPostMutation.graphql';
import { PostSelectButton } from '../../components/SelectButton';
import getClientMutationId from '../../utils/getClientMutationId';

export const formActions = [
  {
    description: getPostLabel,
    permissionLabel: 'Post Prepayment/Accrual',
    screenReference: 'Post Prepayment/Accrual',
    component: PostSelectButton,
    fn: postAccrualPrepayment,
    individualButton: true,
    performSave: true,
    saveMessage: 'Accrual/Prepayment posted',
    condition: canBePosted,
  },
];

function getPostLabel(values) {
  return values && values.accrualPrepayment && values.accrualPrepayment === 'PREPAYMENT'
    ? 'Post Prepayment'
    : 'Post Accrual';
}

function canBePosted(AccrualPrepayment) {
  if (AccrualPrepayment && AccrualPrepayment.documentStatus) {
    return AccrualPrepayment.documentStatus === 'DRAFT';
  }
  return false;
}

function postAccrualPrepayment(props) {
  const { values, connectedForm } = props;
  if (hasValidationErrors(connectedForm)) return;
  const input = {
    clientMutationId: getClientMutationId(),
    id: values.id,
  };
  createBackgroundProcess(NominalAccrualPrepaymentPostMutation, input, props, 'back', 'Post Accrual/Prepayment');
}
